import { getRecommendedArticles } from 'lib/data/recommendations';
import { useEffect } from 'react';
import { useAppState } from './useAppState';

export const useFetchScrollArticles = ({ enabled }: { enabled: boolean }) => {
  const [, appStateDispatcher] = useAppState();

  useEffect(() => {
    if (!enabled) return;

    (async () => {
      const { recommended_articles = [], scroll_articles = [] } = await getRecommendedArticles();

      appStateDispatcher({
        recommendedArticles: recommended_articles,
        scrollArticles: scroll_articles,
      });
    })();
  }, [enabled]);
};
